// extracted by mini-css-extract-plugin
export default {"tabclix_donation_button":"donationButton_tabclix_donation_button__O1yR7","button":"donationButton_button__3I7yF"};